import type { BusinessHours, PikcupPointType } from '../types/PikcupPointType';
import { setLocalStorage } from './localStorage';

export const pickupSetData = (
  pickupAddress?: PikcupPointType,
  pickupTimes?: BusinessHours
) => {
  const pickupInfos = JSON.stringify({
    pickupTimes: pickupTimes,
    pickupPointName: String(pickupAddress?.name),
  });
  setLocalStorage('postalCode', String(pickupAddress?.address.postalCode));
  setLocalStorage('method', 'pickup-in-point');
  setLocalStorage('pickupInfos', pickupInfos);
};
